"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = void 0;
var user_1 = require("../user");
var date_fns_1 = require("date-fns");
var Subscription = /** @class */ (function () {
    function Subscription(init) {
        Object.assign(this, __assign(__assign({}, init), { startDate: new Date(init.startDate) }));
    }
    Subscription.prototype.isSusbscriptionActive = function () {
        var endDate = this.getEndDate();
        return this.startDate.getTime() <= endDate.getTime();
    };
    Subscription.prototype.subscriptionSatisfyOffer = function (offer) {
        return this.offer >= offer;
    };
    Subscription.prototype.getEndDate = function () {
        var endDate = this.period === user_1.SubscriptionPeriodEnum.month ? (0, date_fns_1.addMonths)(this.startDate, this.duration) : (0, date_fns_1.addYears)(this.startDate, this.duration);
        return endDate;
    };
    return Subscription;
}());
exports.Subscription = Subscription;
